import { UserSubscription, UserSubscriptionStatus } from 'src/types/hhpro';

import { SubscriptionAction } from 'src/hooks/hhPro/usePayment';

const useSubscribeAction = (subscription?: UserSubscription): SubscriptionAction | null => {
    if (subscription?.active) {
        return SubscriptionAction.Cancel;
    }

    if (subscription?.status === UserSubscriptionStatus.Suspended) {
        return SubscriptionAction.Renew;
    }

    return SubscriptionAction.Payment;
};

export default useSubscribeAction;
